import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import DeliveryTimer from "./DeliveryTimer";
import UpdatePopup from "./UpdatePopup";
import PullToRefresh from "react-simple-pull-to-refresh";

import NavBar from "./navbar/navbar";
import Slider from "./component/slider";
import "./App.css";
import ShopForm from "./component/ShopForm";
import ShopCard from "./component/ShopCard";
import FruitShopCard from "./component/FruitShopCard";
import MissionComponent from "./component/MissionComponent";
import Footer from "./Footer";
import LoginPage from "./component/LoginPage";
import RegistrationPage from "./component/RegistrationPage";
import ResetPassword from "./component/ResetPassword";
import OfferShop from "./component/offershop";
import ShopProfile from "./shop_profile/ShopProfile";
import Cart from "./cart/Cart";
import LocationMap from "./LocationMap";
import Checkoutdata from "./checkoutform/Checkoutdata";
import OfferShopProfile from "./offer_shop_profile/OfferShopProfile";
import MyOrderInfo from "./userorder/MyOrderInfo";
import { analytics, logEvent } from "./firebase";
import CustomerReels from "./component/CustomerReels";

//count down
//const targetDate = new Date("2025-06-14T09:00:00+05:30");

function CountdownOverlay() {
  const [show, setShow] = React.useState(false);
  const [timeLeft, setTimeLeft] = React.useState(0);

  const updateOverlayState = () => {
    const now = new Date();

    // Convert to IST (Indian Standard Time)
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const istNow = new Date(utc + 5.5 * 60 * 60 * 1000);

    const istHours = istNow.getHours();

    console.log("⏰ IST Time:", istNow.toLocaleTimeString());

    // Active if between 8:00 PM (20:00) and next day 8:00 AM (08:00)
    const isWithinCountdownWindow = istHours >= 20 || istHours < 8;

    if (isWithinCountdownWindow) {
      const endTime = new Date(istNow);

      // If it's night (20:00 or later), set end time to next day's 08:00
      if (istHours >= 20) {
        endTime.setDate(endTime.getDate() + 1);
      }

      endTime.setHours(8, 0, 0, 0); // Set to 08:00 AM IST

      const diff = endTime - istNow;
      setTimeLeft(diff);
      setShow(true);
    } else {
      setShow(false);
    }
  };

  //log view

  React.useEffect(() => {
    updateOverlayState();
    const interval = setInterval(updateOverlayState, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!show || timeLeft <= 0) return null;

  const totalSeconds = Math.floor(timeLeft / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        color: "#111",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        textAlign: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderRadius: "12px",
          padding: "20px 30px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          maxWidth: "90%",
        }}
      >
        <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
          🚧 We’re Closed for the Day! Back at morning 8:00 AM
        </h2>
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            marginBottom: "8px",
          }}
        >
          {hours}h {minutes}m {seconds}s
        </h1>
        <p style={{ marginTop: 6, fontSize: "14px" }}>
          Please visit again after 8:00 AM
        </p>
      </div>
    </div>
  );
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();
  const hasResumedOnce = useRef(false);

  //count down
  // const [showOverlay, setShowOverlay] = useState(new Date() < targetDate);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollX !== 0) {
        window.scrollTo(0, window.scrollY); // Lock to X = 0
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  window.gtag("event", "home screen ", {
    screen_name: "home screen visited",
    phone: userEmail,
  });

  //refresh on every load
  useEffect(() => {
    let lastHiddenTime = null;

    const handleVisibilityChange = () => {
      const now = Date.now();

      if (document.visibilityState === "visible") {
        // If it was hidden for more than 3 seconds, refresh
        if (lastHiddenTime && now - lastHiddenTime > 3000) {
          window.location.reload();
        }
        lastHiddenTime = null;
      } else {
        lastHiddenTime = now;
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // Load session from localStorage on app start
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const email = localStorage.getItem("userEmail");
    const phoneNumber = localStorage.getItem("userPhoneNumber");

    if (token && email && phoneNumber) {
      setIsLoggedIn(true);
      setUserEmail(email);
      setUserPhoneNumber(phoneNumber);

      const savedCart = JSON.parse(localStorage.getItem(`cart_${email}`)) || [];
      setCart(savedCart);
    }
  }, []);

  useEffect(() => {
    console.log("Cart updated:", cart);
  }, [cart]);

  const handleAddToCart = (item) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((cartItem) => cartItem.id === item.id);
      const updatedCart = existingItem
        ? prevCart.map((cartItem) =>
            cartItem.id === item.id
              ? { ...cartItem, quantity: cartItem.quantity + 1 }
              : cartItem
          )
        : [...prevCart, { ...item, quantity: 1 }];

      if (userEmail) {
        localStorage.setItem(`cart_${userEmail}`, JSON.stringify(updatedCart));
      }

      return updatedCart;
    });
  };

  const refreshCart = async () => {
    if (!userEmail) return;

    try {
      const response = await fetch(
        `https://yaasaai.com/myphpapi/getcartdata.php?phoneNumber=${encodeURIComponent(
          userEmail
        )}`
      );

      if (!response.ok) {
        console.error("Failed to refresh cart:", response.status);
        return;
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setCart(data);
        localStorage.setItem(`cart_${userEmail}`, JSON.stringify(data));
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error refreshing cart:", error);
    }
  };

  const handleLoginSuccess = (token, email, phoneNumber) => {
    localStorage.setItem("authToken", token);
    localStorage.setItem("userEmail", email);
    localStorage.setItem("userPhoneNumber", phoneNumber);
    setIsLoggedIn(true);
    setUserEmail(email);
    setUserPhoneNumber(phoneNumber);
    navigate("/");
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userPhoneNumber");
    setIsLoggedIn(false);
    setUserEmail("");
    setUserPhoneNumber("");
    setCart([]);
    navigate("/");
  };

  const handleCartClick = () => {
    navigate("/cart");
  };

  return (
    <>
      {isLoggedIn && <CountdownOverlay />}

      <NavBar
        userEmail={userEmail}
        userPhoneNumber={userPhoneNumber}
        onLogout={handleLogout}
        cart={cart}
        onCartClick={handleCartClick}
      />

      <Routes>
        {!isLoggedIn ? (
          <>
            <Route
              path="/"
              element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
            />
            <Route path="/RegistrationPage" element={<RegistrationPage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </>
        ) : (
          <>
            <Route
              path="/"
              element={
                <PullToRefresh
                  onRefresh={async () => window.location.reload()}
                  pullingContent={
                    <div style={{ textAlign: "center" }}>
                      Pull to refresh...
                    </div>
                  }
                  refreshingContent={
                    <div style={{ textAlign: "center" }}>Refreshing...</div>
                  }
                >
                  <div
                    style={{
                      overflowX: "hidden",
                      width: "100%",
                      maxWidth: "100vw",
                    }}
                  >
                    <Slider />
                    <ShopForm />

                    {/* Wrap DeliveryTimer in a flex container to center it */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: 24,
                      }}
                    >
                      {/* <DeliveryTimer userEmail={userEmail} />  */}
                    </div>

                    <OfferShop />
                    <ShopCard />
                    <FruitShopCard />
                    <MissionComponent />
                    <Footer />
                  </div>
                </PullToRefresh>
              }
            />

            <Route
              path="/shop_profile"
              element={
                <PullToRefresh
                  onRefresh={async () => window.location.reload()}
                  pullingContent={
                    <div style={{ textAlign: "center" }}>
                      Pull to refresh...
                    </div>
                  }
                  refreshingContent={
                    <div style={{ textAlign: "center" }}>Refreshing...</div>
                  }
                >
                  <ShopProfile
                    userPhoneNumber={userPhoneNumber}
                    userEmail={userEmail}
                    addToCart={handleAddToCart}
                    cart={cart}
                    refreshCart={refreshCart}
                  />
                </PullToRefresh>
              }
            />

            <Route
              path="/customer_reels"
              element={
                <CustomerReels
                  userPhoneNumber={userPhoneNumber}
                  userEmail={userEmail}
                />
              }
            />

            <Route
              path="/offer_shop_profile"
              element={
                <PullToRefresh
                  onRefresh={async () => window.location.reload()}
                  pullingContent={
                    <div style={{ textAlign: "center" }}>
                      Pull to refresh...
                    </div>
                  }
                  refreshingContent={
                    <div style={{ textAlign: "center" }}>Refreshing...</div>
                  }
                >
                  <OfferShopProfile
                    userPhoneNumber={userPhoneNumber}
                    userEmail={userEmail}
                    addToCart={handleAddToCart}
                    cart={cart}
                  />
                </PullToRefresh>
              }
            />

            <Route path="/location" element={<LocationMap />} />

            <Route
              path="/checkoutform"
              element={
                <PullToRefresh
                  onRefresh={async () => window.location.reload()}
                  pullingContent={
                    <div style={{ textAlign: "center" }}>
                      Pull to refresh...
                    </div>
                  }
                  refreshingContent={
                    <div style={{ textAlign: "center" }}>Refreshing...</div>
                  }
                >
                  <Checkoutdata userEmail={userEmail} />
                </PullToRefresh>
              }
            />

            <Route
              path="/userorder"
              element={<MyOrderInfo userPhoneNumber={userEmail} />}
            />

            <Route
              path="/cart"
              element={
                <PullToRefresh
                  onRefresh={async () => window.location.reload()}
                  pullingContent={
                    <div style={{ textAlign: "center" }}>
                      Pull to refresh...
                    </div>
                  }
                  refreshingContent={
                    <div style={{ textAlign: "center" }}>Refreshing...</div>
                  }
                >
                  <Cart
                    cart={cart}
                    userEmail={userEmail}
                    userPhoneNumber={userPhoneNumber}
                  />
                </PullToRefresh>
              }
            />
          </>
        )}
      </Routes>
    </>
  );
}

export default App;
